import React from "react";
import { motion } from "framer-motion";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { initialResearch } from "../data/initialData";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const Research = () => {
  const [research] = useLocalStorage('research', initialResearch);

  return (
    <motion.section
      id="research"
      className="py-24 relative overflow-hidden bg-slate-900/50"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      variants={containerVariants}
    >
      <div className="absolute inset-0 bg-grid opacity-20" />

      <motion.div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px]"
        animate={{ x: [0, -60, 0], y: [0, 40, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="section-container relative z-10">
        <motion.div className="text-center mb-16" variants={itemVariants}>
          <motion.span
            className="inline-block px-4 py-1.5 mb-4 text-xs font-mono tracking-wider text-cyan-400 border border-cyan-500/30 rounded-full bg-cyan-500/5"
          >
            Research
          </motion.span>
          <motion.h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Research & <span className="gradient-text">Innovation</span>
          </motion.h2>
          <motion.p className="text-slate-400 max-w-2xl mx-auto text-base">
            Advancing language technology at the intersection of engineering and research
          </motion.p>
        </motion.div>

        <motion.div
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
          variants={containerVariants}
        >
          {research.map((r, i) => (
            <motion.div
              key={r.area}
              variants={itemVariants}
              className="glass-card rounded-xl p-5 hover:border-cyan-500/20 transition-all duration-300 group"
              whileHover={{ y: -3 }}
            >
              <div className="flex items-start gap-3">
                <span className="text-xs font-mono text-cyan-500/60 mt-0.5 flex-shrink-0">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-white mb-1.5 group-hover:text-cyan-300 transition-colors">
                    {r.area}
                  </h3>
                  <p className="text-xs text-slate-400 leading-relaxed">
                    {r.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Research;
